
























import { Component, Vue } from 'vue-property-decorator';
import Comments from '@/modules/comments/Comments.vue';
import EventsWidget from '@/modules/events/components/EventsWidget/EventsWidget.vue';
import LeagueTable from '@/modules/league/components/LeagueTable.vue';
import SiteForDisplay from '@/modules/sites/components/SiteForDisplay.vue';
import NextMatchWidget from '@/modules/league/components/NextMatchWidget.vue';
import LastMatchWidget from '@/modules/league/components/LastMatchWidget.vue';
import LastMatchDayResultsWidget from '@/modules/league/components/LastMatchDayResultsWidget.vue';

@Component({
  components: {
    Comments,
    EventsWidget,
    LeagueTable,
    SiteForDisplay,
    NextMatchWidget,
    LastMatchWidget,
    LastMatchDayResultsWidget,
  },
})
export default class Home extends Vue {
}
